// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CSS Wrapper for FWA */
/* Start */
.n-style .widget-warpper h1, .n-style .widget-warpper h2, .n-style .widget-warpper h3, .n-style .widget-warpper h4, .n-style .widget-warpper h5, .n-style .widget-warpper h6,
.widget-warpper h1 span, .n-style .widget-warpper h2 span, .n-style .widget-warpper h3 span, .n-style .widget-warpper h4 span, .n-style .widget-warpper h5 span, .n-style .widget-warpper h6 span,
.n-style .widget-warpper div, .n-style .widget-warpper p, .n-style .widget-warpper span, .n-style .widget-warpper a, .n-style .widget-warpper input, .n-style .widget-warpper textarea, .n-style .widget-warpper select,
.n-style .widget-warpper div, .n-style .widget-warpper p, .n-style .widget-warpper span, .n-style .widget-warpper a, .n-style .widget-warpper input, 
.n-style .widget-warpper textarea, .n-style .widget-warpper select, .n-style .widget-warpper table, .n-style .widget-warpper li,
.n-style .widget-warpper label, .n-style .widget-warpper label div, .n-style .widget-warpper label p, .n-style .widget-warpper label span, .n-style .widget-warpper label a, input, textarea, select, html, body{
    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif !important;
}

.n-style .widget-warpper .Button:hover,.widget-warpper .Button:active, .n-style .widget-warpper .Button.is-active, .n-style .widget-warpper .Button.link.active, 
.n-style .widget-warpper .Button.link.hover, .n-style .widget-warpper .n-style .Button.link:active, .n-style .widget-warpper .n-style .Button.link:hover, .n-style .widget-warpper button:hover, 
.n-style .widget-warpper button:active, .n-style .widget-warpper button.is-active, .n-style .widget-warpper button.link.active, .n-style .widget-warpper button.link.hover, 
.n-style .widget-warpper button.link:active, .n-style .widget-warpper button.link:hover, .n-style .widget-warpper a.Button:hover, .n-style .widget-warpper a.Button:active, 
.n-style .widget-warpper a.Button.is-active, .n-style .widget-warpper a.Button.link.active, .n-style .widget-warpper a.Button.link.hover, .n-style .widget-warpper a.Button.link:active, 
.n-style .widget-warpper a.Button.link:hover{
    /* background-color: inherit !important;
    color: inherit !important;
    border-color: inherit !important;
    border-radius: inherit !important; */
}

.widget-warpper {
    width: auto;
    margin: 0px auto;
    padding-top: 0rem;
    padding-left: 0rem;
}

.widget-warpper a:hover,.widget-warpper a.is-hover,.widget-warpper .Link:hover,.widget-warpper .Link.is-hover {
    color:#000000;
}

#portal table th:last-of-type,#portal .Table th:last-of-type, .widget-warpper table th:last-of-type,.widget-warpper .Table th:last-of-type {
    border-right-color: transparent;
}

.widget-warpper table {
    border: none !important;
}

.widget-warpper table th{
background-color: transparent !important;
border-bottom: .0625rem solid #000 !important;
}

.widget-warpper table td{
    border: none !important;
}

#portal table {
    border: none !important;
}

#portal table th{
background-color: transparent !important;
border-bottom: .0625rem solid #000 !important;
}

#portal table td{
    border: none !important;
}

/* #portal [class^=ModalDialog-VDS]
{
  width: 60% !important;
 } */

 #portal #close-button:hover{
    background-color: transparent !important;
    color: #000 !important;
 }
 .widget-warpper #close-button:hover{
    background-color: transparent !important;
    color: #000 !important;
 }
.widget-warpper button[class*=StyledTabButton-VDS]:hover, .widget-warpper button[class*=StyledAccordionButton-VDS]:hover, .widget-warpper button[class*=AnchorIconBase-VDS]:hover {
    background-color: transparent !important;  
    border-color: transparent;
}
#portal button[class*=StyledAccordionButton-VDS]:hover {
    background-color: transparent !important;  
    border-color: transparent;
}
#portal div[class^=Overlay-VDS]
{
    background-color:rgba(0, 0, 0, 0.8) !important;
}
.widget-warpper  div[class*=ButtonIconContainer-VDS] > button:hover{
    background-color: transparent !important;
    border-color: transparent;
}
.widget-warpper  .breadcrumb-container button:hover{
    background-color: transparent !important;
    color: #000 !important;
    border-color: transparent;
}
.widget-warpper  button[class*=CloseButton-VDS]:hover{
    background-color: transparent !important;
    color: #000 !important;
    border-color: transparent;
}

.widget-warpper button[id*=notificationCloseButton]:hover{
    background-color: transparent !important;
}

.widget-warpper  button[name=secondary-button]:hover{
    background-color: transparent;
    border: 0.0625rem solid #000000;
    color: #000000;
}

#portal  button[name=secondary-button]:hover{
    background-color: transparent;
    border: 0.0625rem solid #000000;
    color: #000000;
}
.widget-warpper .container{
    width: auto !important;
}
.widget-warpper .sales-rep-pod a:hover, .sales-rep-pod a:focus {
    color:#ffffff;
}
/* End */
@media (hover:hover) {
    .widget-warpper .Button:hover, #portal .Button:hover, #portal button:hover{
        background-color: unset;
        color: unset;
        border-color: #fff;
    }
}
.widget-warpper input[type=radio]+label::before, .widget-warpper input[type=radio]:hover+label::before {
    content: "" !important;
}
.widget-warpper input.value, .widget-warpper textarea.value  {
    background-color: transparent;
   color: rgb(0, 0, 0);
}
.widget-warpper input  {
    font-weight: initial;
}
.widget-warpper .progress {
    margin: 0px;
}
.widget-warpper #otpNumbers input[type=checkbox]+label, .widget-warpper #otpNumbers input[type=radio]+label {
    padding: 0px !important;
    padding-left: 8px !important;
    font-weight: initial;
}

.widget-warpper #mitekOptions input[type=checkbox]+label, .widget-warpper #mitekOptions input[type=radio]+label  {
    padding: 0px !important;
    padding-left: 8px !important;
}

.widget-warpper.checkboxgrp label {
    padding: 0px !important;
    padding-left: 8px !important;
    line-height: 1.25rem;
}
.widget-warpper input:focus  {
    background-color: transparent !important;
}
.widget-warpper .required-arrow{
    float: right;
  }
 .widget-warpper .required-arrow .arrow-left{
  display: inline-block;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 14px solid #cd040b;
 }
 .widget-warpper .required-arrow .required-label {
  display: inline-block;
  width: 54px;
  background:#cd040b;
  position: relative;
  text-align: center;
  font-size: 8px;
  max-height: 20px;
  top: -3px;
  color: #fff;
 }
[class^=StyledAccordionDetail-VDS] > .rah-static{
    overflow: visible !important;
}

.widget-warpper .modal-bba-footer{
    position: sticky;
    bottom: 0px;
    background: #d8dada;
    padding: 40px;
    padding-left: 2rem;
    display: flex;
    align-items: center;
}
.widget-warpper .send-mail{
    background: rgb(255, 0, 0);
    outline: none;
    border: none;
    height: 2.6rem;
    margin-left: 3rem;
    margin-top: 1.25rem;
    color: white;
    width: 7rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}
.widget-warpper .send-mail:disabled{
    background: rgb(255, 0, 0,0.4);
}
.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS]{
    padding: 0 !important;
    max-height: 600px;
    height: 100%;
    border-radius: 0;
}

.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS] > [class^=ModalDialogWrapper-VDS],
.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS] > [class^=ModalDialogWrapper-VDS] > span,
.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS] > [class^=ModalDialogWrapper-VDS] > span > div{
    height: 100% !important;
    padding: 0px !important;
}
.widget-warpper.simplex_section.m_action .simplex_panel-wrap.customer-profile_panel-wrap .simplex_panel.active{
    height: 100% !important;
}
.widget-warpper .billing-information{
    max-width: 550px;
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
}
 .account-modal{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    row-gap: 1rem;
    column-gap: 1rem;
}

.account-page{
  display: grid;
    grid-template-columns: repeat(3,1fr);
    row-gap: 1rem;
    column-gap: 1rem;
    margin:2rem
}
.select-account{
    display: grid;
    grid-template-columns: repeat(4,1fr);
    row-gap: 1rem;
    column-gap: 1rem;
}


 .sales-rep-modal-boxes{
    display: flex;
    flex-wrap: wrap;
}

.loc-saved-addr{
    border: 1px solid #D8DADA;
    min-width: 276px;
    max-width: 304px;
    min-height: 142px;
    padding:1.25rem;
}

.widget-warpper .m-body > div {
    padding-top: 0;
}
.widget-warpper .m-body h5{
padding-bottom: 1.5rem;
}

 #footer-account{
    display: flex;
        gap: 1rem;
}
 #footer-account-page{
    display: flex;
        gap: 1rem;
}
.b-right{
    float: right;
}
#footer-account button{
    min-width: 226px;
}
 #footer-account-page button{
    min-width: 226px;
    margin: 2px;
}

.widget-warpper .location-addr >p{
    padding-bottom: 6px;
}
.widget-warpper [class^=InputStepperWrapper-VDS] button{
    background-color: transparent;
  }
.widget-warpper [class^=SubtitleWrapper-VDS] h1 span{
    color:#ffffff !important;
} 
@media screen and (min-width:768px) {

 .sales-rep-modal{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    margin-top: 2rem;
    gap: 6px;
}
 .sales-rep-modal > div {
    min-width: 200px;
    min-height: 200px;
}
}

@media screen and (max-width:767px) {
    .widget-warpper .pdp-pln-btn{
    display: inline;
   row-gap: 1rem;
}
     .sales-rep-modal {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
        margin-top: 2rem;
        gap: 6px;
    }
     .sales-rep-modal > div {
        min-height: 200px;
    }
}
 #account-modal-buss [class^=RadioBoxLabelWrapper-VDS]{
    max-height: 109px;
}

 #account-modal-buss footer{
    position: sticky;
    bottom: -2px;
    background-color: white;
    width: 100%;
    z-index: 1;
}
#account-modal-buss > div > div > div > div{
    width: 50%;
    /* min-width: 700px; */
    min-width:560px;
    /* max-height: 609px; */
    height: 100%;
}
 #account-modal-buss [class^=ModalDialogWrapper-VDS] [class^=StyledHeader-VDS]{
    height: auto !important;
}
 #account-modal-buss [class^=ModalDialogWrapper-VDS]{
    overflow-y: auto;
}
#account-modal-buss [class^=ModalDialogWrapper-VDS],
#account-modal-buss [class^=ModalDialogWrapper-VDS] > span:first-child,
 #account-modal-buss [class^=ModalDialogWrapper-VDS] > span:first-child > div:first-child{
    height: 100% ;
}

 #account-modal-buss [class^=StyledModalBody-VDS]{
    margin-bottom: 4rem;
}
 #account-modal-buss footer{
    padding-top: 1rem;
}
@media screen and (min-width:768px) {
 #account-modal-buss > div > div > div > div{
    padding:48px 0 48px 48px !important;
    }
}
@media screen and (max-width:767px) {
  .select-account{
        display: flex;
        flex-direction: column;
    }
   #account-modal-buss > div > div > div > div{
        width: 100%;
        min-width: 100%;
    }
    /* #account-modal-buss footer{
        position: absolute;
        bottom: 0px;
        width: 98%;
        background-color: white;
    } */
    #account-modal-buss footer > button{
        bottom: 12px;
        width: 96%;
    }
}
.widget-warpper button[class^="VBG__DS__tag-module__"]:hover
{
    background-color: #F8F3E9 !important;
}
.widget-warpper button[class^="VBG__DS__tag-module__"]
{
    border-radius: 0 !important;
}
.widget-warpper .service-information{
    padding: 1rem 1.5rem;
    border: 2px solid #000000;
    max-width: 350px;
    border-radius: 4px;
    margin-right: 10px;
}
.widget-warpper .serviceInfoContainer{
    display: grid;
    grid-template-columns: repeat(1,1fr);
}
.widget-warpper .aligningInfoManage{
        display: inline;
    }
.widget-warpper .aligningInfoManage > .serInfoManage{
    margin: 3rem 0;
}
@media screen and (max-width:767px) {
    .widget-warpper {
        padding-left: 0rem;
    } 
}


 /* .widget-warpper button span{
    font-family: Verizon-NHG-eTX !important;
 } */


 .widget-warpper .input-box-wrapper-account{
    display: flex;
    margin-bottom: 1rem;
 }
 .widget-warpper .input-box-select-account{
    display: flex;
    margin-bottom: 1rem;
    justify-content: end;

 }
 .widget-warpper .account-div{
    padding: 1.5rem 1rem;
    min-width: 200px;
    margin: 1rem;
    cursor: pointer;
 }
 .widget-warpper .total-acc{
    margin-right: 1rem;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    max-width: 180px;
 }

 @media screen and (max-width:767px) {
    .widget-warpper .input-box-wrapper-account{
        display: inline;
    }
    .widget-warpper .account-modal{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        margin-top: 2rem;
    }
    .widget-warpper .sales-rep-modal{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        margin-top: 2rem;
    }
    .widget-warpper .total-acc{
        margin-top: 0.5rem;
        max-width: 150px;
        width: 100%;
        display: inline;
    }

    .widget-warpper .input-box-select-account .buss-search{
        width: 100%;
    }
    .widget-warpper .input-box-select-account .buss-search input{
        width: 100%;
        margin-bottom: 1rem;
    }
    .widget-warpper .op-boxes [class^=SubtitleWrapper-VDS] > h2{
        font-size: 1rem !important;
      }
      .widget-warpper .info-op-cont >  p, .widget-warpper .info-op-cont > a > span{
        font-size: 1rem !important;
      }
      .widget-warpper .op-boxes > div > div {
        width: auto !important;
      }
      .widget-warpper [class^=StyledAccordionDetail-VDS] > .rah-static > div > div{
        font-size: 1rem !important;
      }
      .widget-warpper [class^=StyledAccordionButton-VDS] > div > h5{
          font-size: 1.25rem !important;
        }
    .widget-warpper h3 span{
            font-size: 1.5rem !important;
    }
    
.widget-warpper #account-modal-buss  [class^="StyledFooter-VDS"] {
   position: fixed;
    bottom: 0;
    z-index: 100;
    padding: .6rem;
    background-color: white;
    left: 0;

}
 }
 .widget-warpper .op-boxes>div {
        height: 285px;
    }
 .widget-warpper .marketplace-pdp-section > div:first-child{
    max-width: 1272px !important;
    margin-left: auto !important;
    margin-right: auto !important;
 }
#red-dot-buss{
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: red;
    position: relative;
    left: 10px;
    bottom: 22px;
}
.widget-warpper .mar-tp-24{
    margin-top: 24px !important;
}
.widget-warpper .mar-rt-1{
    margin-right: 1rem;
}
.widget-warpper .mar-tp-8{
    margin-top: 0.8rem !important;
}
#portal .word-break{
    word-break: break-word;
}
.widget-warpper .prd-brd-mktplc [class^=StyledAccordionButton-VDS]{
	padding-right:0px
}

/* .navbar-bottom{
    margin-bottom: 7rem !important;
} */

.n-style .widget-warpper .custom-fm p,
.n-style .widget-warpper .tax-fm,
.n-style .widget-warpper .cutom-fm-span,
 .custom-fm p,
 .tax-fm,
 .cutom-fm-span{
    font-size: 0.75rem;
    font-weight: 400;
    font-family: Verizon-NHG-eTX, Helvetica, Arial, sans-serif !important;
}

.cutom-fm-span{
    color: #ffffff;
}
.tax-fm{
color: rgb(167, 167, 167);
display: inline-block;
}
#termsModal [class^="ModalDialog-VDS"] {
    @media only screen and (min-width:767px){
    width:44rem !important;
    }
}
body:has(.widget-warpper) .page-wraper-content
{
    overflow: visible !important;    
}
.widget-warpper .device-shipping-mrkt{
    display: flex;
    align-items: flex-start;
    column-gap: 1rem;
}
.widget-warpper .pdp-button{
    @media only screen and (max-width:767px) {
        width:100%;
    }
}
.widget-warpper .pdp-pln-btn{
    display: flex;
    align-items: flex-end;
    column-gap: 1rem;
}

.widget-warpper .st-p{
font-size: 1rem;
    font-weight: 400;
    line-height: 1.25rem;
    font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;
        margin-bottom: .875rem;

}

.widget-warpper .st-p a {
    
    border: 0;
    border-bottom: 0.0625rem solid #000000;
    box-sizing: border-box;
    color: #000000;
    cursor: pointer;
    outline: none;
    position: relative;
    -webkit-text-decoration: none;
    text-decoration: none;
    touch-action: manipulation;
    
}

.widget-warpper .new-vz-stppr{
    width: 100%;
    padding-right: 2rem;
    max-width: 1272px;
    margin-left: auto;
    margin-right: auto;
}
.widget-warpper .new-vz-stppr > div:first-child{
    overflow-x: auto !important;
}
.plans-new-container-nw-one{
    display: flex;
    column-gap: 1rem;
}
.lft-sct-nw{
    width: 274px;
}
.rgt-sect-nw{
width: calc(100% - 274px);
}
@media screen and (max-width:767px){
    .widget-warpper .new-vz-stppr > div:first-child > div{   
       min-width: 3rem;
        }
    [id^=accordionDetail_accordion-plan-monarch] > div:first-child,[id^=accordionDetail_accor-monar-mybiz-plan] > div:first-child{
       width: 90vw;
    }
    .plans-new-container-nw-one{
    display: inline;
    row-gap: 1rem;
    }
    .lft-sct-nw,.rgt-sect-nw{
        width: 100%;
    }
    }

    [id^=accordionDetail_accordion-plan-monarch] > div:first-child{
        width: 100%;
    }
    .pln-tle-vbgds > div > div > div > div:first-child {
      z-index: 1;
    }
    /* .pln-tle-vbgds > div > div > div > div > [class^=VBG__DS__cap-module]{
      width: 100% !important;
    }
     */
    [id^=accordionDetail_accor-monar-company-plan] > div ,[id^=accordionDetail_accor-monar-mybiz-plan] > div,[id^=accor-monar-company-plan] > div{
      padding-bottom: 0px !important;
    }
    .mock-crt-icon{
    position: absolute;
    width: 20px;
    height: 20px;
    background: transparent;
    cursor: pointer;
    z-index: 999997;
}
.lt-sec-nw-ctnr{
    height: 400px;
    overflow-y: auto;
}
#accordionItemDetail_accordion-plan-monarch-plans-new-ctnr_0 > div:first-child, #accordionItemDetail_accordion-plan-monarch-plans-new-ctnr_1 > div:first-child{
    padding-bottom: 0px !important;
}
.fcc-bl-main-container{
    max-height: 150px;
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/WidgetsDecider.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB,UAAU;AACV;;;;;;IAMI,qEAAqE;AACzE;;AAEA;;;;;;IAMI;;;wCAGoC;AACxC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;AACA,wCAAwC;AACxC,6CAA6C;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;AACA,wCAAwC;AACxC,6CAA6C;AAC7C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;;IAGI;;CAEH;IACG,wCAAwC;IACxC,sBAAsB;CACzB;CACA;IACG,wCAAwC;IACxC,sBAAsB;CACzB;AACD;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;;IAEI,8CAA8C;AAClD;AACA;IACI,wCAAwC;IACxC,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,wCAAwC;IACxC,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,cAAc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;AACjB;AACA,QAAQ;AACR;IACI;QACI,uBAAuB;QACvB,YAAY;QACZ,kBAAkB;IACtB;AACJ;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,6BAA6B;GAC9B,mBAAmB;AACtB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,WAAW;AACf;AACA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,oBAAoB;AACxB;AACA;IACI,wCAAwC;AAC5C;AACA;IACI,YAAY;EACd;CACD;EACC,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,gCAAgC;CACjC;CACA;EACC,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,WAAW;CACZ;AACD;IACI,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,0BAA0B;IAC1B,aAAa;IACb,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;;;IAGI,uBAAuB;IACvB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;CACC;IACG,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,aAAa;IACX,oCAAoC;IACpC,aAAa;IACb,gBAAgB;IAChB;AACJ;AACA;IACI,aAAa;IACb,oCAAoC;IACpC,aAAa;IACb,gBAAgB;AACpB;;;CAGC;IACG,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;AACA;AACA,sBAAsB;AACtB;;CAEC;IACG,aAAa;QACT,SAAS;AACjB;CACC;IACG,aAAa;QACT,SAAS;AACjB;AACA;IACI,YAAY;AAChB;AACA;IACI,gBAAgB;AACpB;CACC;IACG,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,6BAA6B;EAC/B;AACF;IACI,wBAAwB;AAC5B;AACA;;CAEC;IACG,aAAa;IACb,qCAAqC;IACrC,gBAAgB;IAChB,QAAQ;AACZ;CACC;IACG,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;AAEA;IACI;IACA,eAAe;GAChB,aAAa;AAChB;KACK;QACG,aAAa;QACb,qCAAqC;QACrC,gBAAgB;QAChB,QAAQ;IACZ;KACC;QACG,iBAAiB;IACrB;AACJ;CACC;IACG,iBAAiB;AACrB;;CAEC;IACG,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,UAAU;AACd;AACA;IACI,UAAU;IACV,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB;CACC;IACG,uBAAuB;AAC3B;CACC;IACG,gBAAgB;AACpB;AACA;;;IAGI,aAAa;AACjB;;CAEC;IACG,mBAAmB;AACvB;CACC;IACG,iBAAiB;AACrB;AACA;CACC;IACG,mCAAmC;IACnC;AACJ;AACA;EACE;QACM,aAAa;QACb,sBAAsB;IAC1B;GACD;QACK,WAAW;QACX,eAAe;IACnB;IACA;;;;;OAKG;IACH;QACI,YAAY;QACZ,UAAU;IACd;AACJ;AACA;;IAEI,oCAAoC;AACxC;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,oBAAoB;IACpB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,oCAAoC;AACxC;AACA;QACQ,eAAe;IACnB;AACJ;IACI,cAAc;AAClB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;;;CAGC;;IAEG;;;CAGH;IACG,aAAa;IACb,mBAAmB;CACtB;CACA;IACG,aAAa;IACb,mBAAmB;IACnB,oBAAoB;;CAEvB;CACA;IACG,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,eAAe;CAClB;CACA;IACG,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;CACnB;;CAEA;IACG;QACI,eAAe;IACnB;IACA;QACI,aAAa;QACb,oCAAoC;QACpC,gBAAgB;IACpB;IACA;QACI,aAAa;QACb,oCAAoC;QACpC,gBAAgB;IACpB;IACA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;IACA;QACI,WAAW;QACX,mBAAmB;IACvB;IACA;QACI,0BAA0B;MAC5B;MACA;QACE,0BAA0B;MAC5B;MACA;QACE,sBAAsB;MACxB;MACA;QACE,0BAA0B;MAC5B;MACA;UACI,6BAA6B;QAC/B;IACJ;YACQ,4BAA4B;IACpC;;AAEJ;GACG,eAAe;IACd,SAAS;IACT,YAAY;IACZ,cAAc;IACd,uBAAuB;IACvB,OAAO;;AAEX;CACC;CACA;QACO,aAAa;IACjB;CACH;IACG,4BAA4B;IAC5B,4BAA4B;IAC5B,6BAA6B;CAChC;AACD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,kBAAkB;AACtB;AACA;IACI,6BAA6B;AACjC;AACA;IACI,sBAAsB;AAC1B;AACA;CACC;AACD;;AAEA;;GAEG;;AAEH;;;;;;IAMI,kBAAkB;IAClB,gBAAgB;IAChB,qEAAqE;AACzE;;AAEA;IACI,cAAc;AAClB;AACA;AACA,yBAAyB;AACzB,qBAAqB;AACrB;AACA;IACI;IACA,sBAAsB;IACtB;AACJ;AACA;;IAEI,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI,aAAa;IACb,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;AACA,eAAe;IACX,gBAAgB;IAChB,oBAAoB;IACpB,0DAA0D;QACtD,sBAAsB;;AAE9B;;AAEA;;IAEI,SAAS;IACT,sCAAsC;IACtC,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;IACrB,0BAA0B;;AAE9B;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;AACtB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;AACA,yBAAyB;AACzB;AACA;IACI;OACG,eAAe;QACd;IACJ;OACG,WAAW;IACd;IACA;IACA,eAAe;IACf,aAAa;IACb;IACA;QACI,WAAW;IACf;IACA;;IAEA;QACI,WAAW;IACf;IACA;MACE,UAAU;IACZ;IACA;;;MAGE;IACF;MACE,8BAA8B;IAChC;IACA;IACA,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["/* CSS Wrapper for FWA */\n/* Start */\n.n-style .widget-warpper h1, .n-style .widget-warpper h2, .n-style .widget-warpper h3, .n-style .widget-warpper h4, .n-style .widget-warpper h5, .n-style .widget-warpper h6,\n.widget-warpper h1 span, .n-style .widget-warpper h2 span, .n-style .widget-warpper h3 span, .n-style .widget-warpper h4 span, .n-style .widget-warpper h5 span, .n-style .widget-warpper h6 span,\n.n-style .widget-warpper div, .n-style .widget-warpper p, .n-style .widget-warpper span, .n-style .widget-warpper a, .n-style .widget-warpper input, .n-style .widget-warpper textarea, .n-style .widget-warpper select,\n.n-style .widget-warpper div, .n-style .widget-warpper p, .n-style .widget-warpper span, .n-style .widget-warpper a, .n-style .widget-warpper input, \n.n-style .widget-warpper textarea, .n-style .widget-warpper select, .n-style .widget-warpper table, .n-style .widget-warpper li,\n.n-style .widget-warpper label, .n-style .widget-warpper label div, .n-style .widget-warpper label p, .n-style .widget-warpper label span, .n-style .widget-warpper label a, input, textarea, select, html, body{\n    font-family: Verizon-NHG-eDS, Helvetica, Arial, sans-serif !important;\n}\n\n.n-style .widget-warpper .Button:hover,.widget-warpper .Button:active, .n-style .widget-warpper .Button.is-active, .n-style .widget-warpper .Button.link.active, \n.n-style .widget-warpper .Button.link.hover, .n-style .widget-warpper .n-style .Button.link:active, .n-style .widget-warpper .n-style .Button.link:hover, .n-style .widget-warpper button:hover, \n.n-style .widget-warpper button:active, .n-style .widget-warpper button.is-active, .n-style .widget-warpper button.link.active, .n-style .widget-warpper button.link.hover, \n.n-style .widget-warpper button.link:active, .n-style .widget-warpper button.link:hover, .n-style .widget-warpper a.Button:hover, .n-style .widget-warpper a.Button:active, \n.n-style .widget-warpper a.Button.is-active, .n-style .widget-warpper a.Button.link.active, .n-style .widget-warpper a.Button.link.hover, .n-style .widget-warpper a.Button.link:active, \n.n-style .widget-warpper a.Button.link:hover{\n    /* background-color: inherit !important;\n    color: inherit !important;\n    border-color: inherit !important;\n    border-radius: inherit !important; */\n}\n\n.widget-warpper {\n    width: auto;\n    margin: 0px auto;\n    padding-top: 0rem;\n    padding-left: 0rem;\n}\n\n.widget-warpper a:hover,.widget-warpper a.is-hover,.widget-warpper .Link:hover,.widget-warpper .Link.is-hover {\n    color:#000000;\n}\n\n#portal table th:last-of-type,#portal .Table th:last-of-type, .widget-warpper table th:last-of-type,.widget-warpper .Table th:last-of-type {\n    border-right-color: transparent;\n}\n\n.widget-warpper table {\n    border: none !important;\n}\n\n.widget-warpper table th{\nbackground-color: transparent !important;\nborder-bottom: .0625rem solid #000 !important;\n}\n\n.widget-warpper table td{\n    border: none !important;\n}\n\n#portal table {\n    border: none !important;\n}\n\n#portal table th{\nbackground-color: transparent !important;\nborder-bottom: .0625rem solid #000 !important;\n}\n\n#portal table td{\n    border: none !important;\n}\n\n/* #portal [class^=ModalDialog-VDS]\n{\n  width: 60% !important;\n } */\n\n #portal #close-button:hover{\n    background-color: transparent !important;\n    color: #000 !important;\n }\n .widget-warpper #close-button:hover{\n    background-color: transparent !important;\n    color: #000 !important;\n }\n.widget-warpper button[class*=StyledTabButton-VDS]:hover, .widget-warpper button[class*=StyledAccordionButton-VDS]:hover, .widget-warpper button[class*=AnchorIconBase-VDS]:hover {\n    background-color: transparent !important;  \n    border-color: transparent;\n}\n#portal button[class*=StyledAccordionButton-VDS]:hover {\n    background-color: transparent !important;  \n    border-color: transparent;\n}\n#portal div[class^=Overlay-VDS]\n{\n    background-color:rgba(0, 0, 0, 0.8) !important;\n}\n.widget-warpper  div[class*=ButtonIconContainer-VDS] > button:hover{\n    background-color: transparent !important;\n    border-color: transparent;\n}\n.widget-warpper  .breadcrumb-container button:hover{\n    background-color: transparent !important;\n    color: #000 !important;\n    border-color: transparent;\n}\n.widget-warpper  button[class*=CloseButton-VDS]:hover{\n    background-color: transparent !important;\n    color: #000 !important;\n    border-color: transparent;\n}\n\n.widget-warpper button[id*=notificationCloseButton]:hover{\n    background-color: transparent !important;\n}\n\n.widget-warpper  button[name=secondary-button]:hover{\n    background-color: transparent;\n    border: 0.0625rem solid #000000;\n    color: #000000;\n}\n\n#portal  button[name=secondary-button]:hover{\n    background-color: transparent;\n    border: 0.0625rem solid #000000;\n    color: #000000;\n}\n.widget-warpper .container{\n    width: auto !important;\n}\n.widget-warpper .sales-rep-pod a:hover, .sales-rep-pod a:focus {\n    color:#ffffff;\n}\n/* End */\n@media (hover:hover) {\n    .widget-warpper .Button:hover, #portal .Button:hover, #portal button:hover{\n        background-color: unset;\n        color: unset;\n        border-color: #fff;\n    }\n}\n.widget-warpper input[type=radio]+label::before, .widget-warpper input[type=radio]:hover+label::before {\n    content: \"\" !important;\n}\n.widget-warpper input.value, .widget-warpper textarea.value  {\n    background-color: transparent;\n   color: rgb(0, 0, 0);\n}\n.widget-warpper input  {\n    font-weight: initial;\n}\n.widget-warpper .progress {\n    margin: 0px;\n}\n.widget-warpper #otpNumbers input[type=checkbox]+label, .widget-warpper #otpNumbers input[type=radio]+label {\n    padding: 0px !important;\n    padding-left: 8px !important;\n    font-weight: initial;\n}\n\n.widget-warpper #mitekOptions input[type=checkbox]+label, .widget-warpper #mitekOptions input[type=radio]+label  {\n    padding: 0px !important;\n    padding-left: 8px !important;\n}\n\n.widget-warpper.checkboxgrp label {\n    padding: 0px !important;\n    padding-left: 8px !important;\n    line-height: 1.25rem;\n}\n.widget-warpper input:focus  {\n    background-color: transparent !important;\n}\n.widget-warpper .required-arrow{\n    float: right;\n  }\n .widget-warpper .required-arrow .arrow-left{\n  display: inline-block;\n  border-top: 8px solid transparent;\n  border-bottom: 8px solid transparent;\n  border-right: 14px solid #cd040b;\n }\n .widget-warpper .required-arrow .required-label {\n  display: inline-block;\n  width: 54px;\n  background:#cd040b;\n  position: relative;\n  text-align: center;\n  font-size: 8px;\n  max-height: 20px;\n  top: -3px;\n  color: #fff;\n }\n[class^=StyledAccordionDetail-VDS] > .rah-static{\n    overflow: visible !important;\n}\n\n.widget-warpper .modal-bba-footer{\n    position: sticky;\n    bottom: 0px;\n    background: #d8dada;\n    padding: 40px;\n    padding-left: 2rem;\n    display: flex;\n    align-items: center;\n}\n.widget-warpper .send-mail{\n    background: rgb(255, 0, 0);\n    outline: none;\n    border: none;\n    height: 2.6rem;\n    margin-left: 3rem;\n    margin-top: 1.25rem;\n    color: white;\n    width: 7rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    cursor: pointer;\n}\n.widget-warpper .send-mail:disabled{\n    background: rgb(255, 0, 0,0.4);\n}\n.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS]{\n    padding: 0 !important;\n    max-height: 600px;\n    height: 100%;\n    border-radius: 0;\n}\n\n.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS] > [class^=ModalDialogWrapper-VDS],\n.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS] > [class^=ModalDialogWrapper-VDS] > span,\n.widget-warpper #bba-lbl > div > div > [class^=Overlay-VDS] > [class^=ModalDialog-VDS] > [class^=ModalDialogWrapper-VDS] > span > div{\n    height: 100% !important;\n    padding: 0px !important;\n}\n.widget-warpper.simplex_section.m_action .simplex_panel-wrap.customer-profile_panel-wrap .simplex_panel.active{\n    height: 100% !important;\n}\n.widget-warpper .billing-information{\n    max-width: 550px;\n    display: flex;\n    justify-content: space-between;\n    margin-top: 24px;\n}\n .account-modal{\n    display: grid;\n    grid-template-columns: repeat(3,1fr);\n    row-gap: 1rem;\n    column-gap: 1rem;\n}\n\n.account-page{\n  display: grid;\n    grid-template-columns: repeat(3,1fr);\n    row-gap: 1rem;\n    column-gap: 1rem;\n    margin:2rem\n}\n.select-account{\n    display: grid;\n    grid-template-columns: repeat(4,1fr);\n    row-gap: 1rem;\n    column-gap: 1rem;\n}\n\n\n .sales-rep-modal-boxes{\n    display: flex;\n    flex-wrap: wrap;\n}\n\n.loc-saved-addr{\n    border: 1px solid #D8DADA;\n    min-width: 276px;\n    max-width: 304px;\n    min-height: 142px;\n    padding:1.25rem;\n}\n\n.widget-warpper .m-body > div {\n    padding-top: 0;\n}\n.widget-warpper .m-body h5{\npadding-bottom: 1.5rem;\n}\n\n #footer-account{\n    display: flex;\n        gap: 1rem;\n}\n #footer-account-page{\n    display: flex;\n        gap: 1rem;\n}\n.b-right{\n    float: right;\n}\n#footer-account button{\n    min-width: 226px;\n}\n #footer-account-page button{\n    min-width: 226px;\n    margin: 2px;\n}\n\n.widget-warpper .location-addr >p{\n    padding-bottom: 6px;\n}\n.widget-warpper [class^=InputStepperWrapper-VDS] button{\n    background-color: transparent;\n  }\n.widget-warpper [class^=SubtitleWrapper-VDS] h1 span{\n    color:#ffffff !important;\n} \n@media screen and (min-width:768px) {\n\n .sales-rep-modal{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    margin-top: 2rem;\n    gap: 6px;\n}\n .sales-rep-modal > div {\n    min-width: 200px;\n    min-height: 200px;\n}\n}\n\n@media screen and (max-width:767px) {\n    .widget-warpper .pdp-pln-btn{\n    display: inline;\n   row-gap: 1rem;\n}\n     .sales-rep-modal {\n        display: grid;\n        grid-template-columns: repeat(1, 1fr);\n        margin-top: 2rem;\n        gap: 6px;\n    }\n     .sales-rep-modal > div {\n        min-height: 200px;\n    }\n}\n #account-modal-buss [class^=RadioBoxLabelWrapper-VDS]{\n    max-height: 109px;\n}\n\n #account-modal-buss footer{\n    position: sticky;\n    bottom: -2px;\n    background-color: white;\n    width: 100%;\n    z-index: 1;\n}\n#account-modal-buss > div > div > div > div{\n    width: 50%;\n    /* min-width: 700px; */\n    min-width:560px;\n    /* max-height: 609px; */\n    height: 100%;\n}\n #account-modal-buss [class^=ModalDialogWrapper-VDS] [class^=StyledHeader-VDS]{\n    height: auto !important;\n}\n #account-modal-buss [class^=ModalDialogWrapper-VDS]{\n    overflow-y: auto;\n}\n#account-modal-buss [class^=ModalDialogWrapper-VDS],\n#account-modal-buss [class^=ModalDialogWrapper-VDS] > span:first-child,\n #account-modal-buss [class^=ModalDialogWrapper-VDS] > span:first-child > div:first-child{\n    height: 100% ;\n}\n\n #account-modal-buss [class^=StyledModalBody-VDS]{\n    margin-bottom: 4rem;\n}\n #account-modal-buss footer{\n    padding-top: 1rem;\n}\n@media screen and (min-width:768px) {\n #account-modal-buss > div > div > div > div{\n    padding:48px 0 48px 48px !important;\n    }\n}\n@media screen and (max-width:767px) {\n  .select-account{\n        display: flex;\n        flex-direction: column;\n    }\n   #account-modal-buss > div > div > div > div{\n        width: 100%;\n        min-width: 100%;\n    }\n    /* #account-modal-buss footer{\n        position: absolute;\n        bottom: 0px;\n        width: 98%;\n        background-color: white;\n    } */\n    #account-modal-buss footer > button{\n        bottom: 12px;\n        width: 96%;\n    }\n}\n.widget-warpper button[class^=\"VBG__DS__tag-module__\"]:hover\n{\n    background-color: #F8F3E9 !important;\n}\n.widget-warpper button[class^=\"VBG__DS__tag-module__\"]\n{\n    border-radius: 0 !important;\n}\n.widget-warpper .service-information{\n    padding: 1rem 1.5rem;\n    border: 2px solid #000000;\n    max-width: 350px;\n    border-radius: 4px;\n    margin-right: 10px;\n}\n.widget-warpper .serviceInfoContainer{\n    display: grid;\n    grid-template-columns: repeat(1,1fr);\n}\n.widget-warpper .aligningInfoManage{\n        display: inline;\n    }\n.widget-warpper .aligningInfoManage > .serInfoManage{\n    margin: 3rem 0;\n}\n@media screen and (max-width:767px) {\n    .widget-warpper {\n        padding-left: 0rem;\n    } \n}\n\n\n /* .widget-warpper button span{\n    font-family: Verizon-NHG-eTX !important;\n } */\n\n\n .widget-warpper .input-box-wrapper-account{\n    display: flex;\n    margin-bottom: 1rem;\n }\n .widget-warpper .input-box-select-account{\n    display: flex;\n    margin-bottom: 1rem;\n    justify-content: end;\n\n }\n .widget-warpper .account-div{\n    padding: 1.5rem 1rem;\n    min-width: 200px;\n    margin: 1rem;\n    cursor: pointer;\n }\n .widget-warpper .total-acc{\n    margin-right: 1rem;\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    max-width: 180px;\n }\n\n @media screen and (max-width:767px) {\n    .widget-warpper .input-box-wrapper-account{\n        display: inline;\n    }\n    .widget-warpper .account-modal{\n        display: grid;\n        grid-template-columns: repeat(2,1fr);\n        margin-top: 2rem;\n    }\n    .widget-warpper .sales-rep-modal{\n        display: grid;\n        grid-template-columns: repeat(2,1fr);\n        margin-top: 2rem;\n    }\n    .widget-warpper .total-acc{\n        margin-top: 0.5rem;\n        max-width: 150px;\n        width: 100%;\n        display: inline;\n    }\n\n    .widget-warpper .input-box-select-account .buss-search{\n        width: 100%;\n    }\n    .widget-warpper .input-box-select-account .buss-search input{\n        width: 100%;\n        margin-bottom: 1rem;\n    }\n    .widget-warpper .op-boxes [class^=SubtitleWrapper-VDS] > h2{\n        font-size: 1rem !important;\n      }\n      .widget-warpper .info-op-cont >  p, .widget-warpper .info-op-cont > a > span{\n        font-size: 1rem !important;\n      }\n      .widget-warpper .op-boxes > div > div {\n        width: auto !important;\n      }\n      .widget-warpper [class^=StyledAccordionDetail-VDS] > .rah-static > div > div{\n        font-size: 1rem !important;\n      }\n      .widget-warpper [class^=StyledAccordionButton-VDS] > div > h5{\n          font-size: 1.25rem !important;\n        }\n    .widget-warpper h3 span{\n            font-size: 1.5rem !important;\n    }\n    \n.widget-warpper #account-modal-buss  [class^=\"StyledFooter-VDS\"] {\n   position: fixed;\n    bottom: 0;\n    z-index: 100;\n    padding: .6rem;\n    background-color: white;\n    left: 0;\n\n}\n }\n .widget-warpper .op-boxes>div {\n        height: 285px;\n    }\n .widget-warpper .marketplace-pdp-section > div:first-child{\n    max-width: 1272px !important;\n    margin-left: auto !important;\n    margin-right: auto !important;\n }\n#red-dot-buss{\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background-color: red;\n    position: relative;\n    left: 10px;\n    bottom: 22px;\n}\n.widget-warpper .mar-tp-24{\n    margin-top: 24px !important;\n}\n.widget-warpper .mar-rt-1{\n    margin-right: 1rem;\n}\n.widget-warpper .mar-tp-8{\n    margin-top: 0.8rem !important;\n}\n#portal .word-break{\n    word-break: break-word;\n}\n.widget-warpper .prd-brd-mktplc [class^=StyledAccordionButton-VDS]{\n\tpadding-right:0px\n}\n\n/* .navbar-bottom{\n    margin-bottom: 7rem !important;\n} */\n\n.n-style .widget-warpper .custom-fm p,\n.n-style .widget-warpper .tax-fm,\n.n-style .widget-warpper .cutom-fm-span,\n .custom-fm p,\n .tax-fm,\n .cutom-fm-span{\n    font-size: 0.75rem;\n    font-weight: 400;\n    font-family: Verizon-NHG-eTX, Helvetica, Arial, sans-serif !important;\n}\n\n.cutom-fm-span{\n    color: #ffffff;\n}\n.tax-fm{\ncolor: rgb(167, 167, 167);\ndisplay: inline-block;\n}\n#termsModal [class^=\"ModalDialog-VDS\"] {\n    @media only screen and (min-width:767px){\n    width:44rem !important;\n    }\n}\nbody:has(.widget-warpper) .page-wraper-content\n{\n    overflow: visible !important;    \n}\n.widget-warpper .device-shipping-mrkt{\n    display: flex;\n    align-items: flex-start;\n    column-gap: 1rem;\n}\n.widget-warpper .pdp-button{\n    @media only screen and (max-width:767px) {\n        width:100%;\n    }\n}\n.widget-warpper .pdp-pln-btn{\n    display: flex;\n    align-items: flex-end;\n    column-gap: 1rem;\n}\n\n.widget-warpper .st-p{\nfont-size: 1rem;\n    font-weight: 400;\n    line-height: 1.25rem;\n    font-family: Verizon-NHG-eDS, Helvetica, Arial, Sans-serif;\n        margin-bottom: .875rem;\n\n}\n\n.widget-warpper .st-p a {\n    \n    border: 0;\n    border-bottom: 0.0625rem solid #000000;\n    box-sizing: border-box;\n    color: #000000;\n    cursor: pointer;\n    outline: none;\n    position: relative;\n    -webkit-text-decoration: none;\n    text-decoration: none;\n    touch-action: manipulation;\n    \n}\n\n.widget-warpper .new-vz-stppr{\n    width: 100%;\n    padding-right: 2rem;\n    max-width: 1272px;\n    margin-left: auto;\n    margin-right: auto;\n}\n.widget-warpper .new-vz-stppr > div:first-child{\n    overflow-x: auto !important;\n}\n.plans-new-container-nw-one{\n    display: flex;\n    column-gap: 1rem;\n}\n.lft-sct-nw{\n    width: 274px;\n}\n.rgt-sect-nw{\nwidth: calc(100% - 274px);\n}\n@media screen and (max-width:767px){\n    .widget-warpper .new-vz-stppr > div:first-child > div{   \n       min-width: 3rem;\n        }\n    [id^=accordionDetail_accordion-plan-monarch] > div:first-child,[id^=accordionDetail_accor-monar-mybiz-plan] > div:first-child{\n       width: 90vw;\n    }\n    .plans-new-container-nw-one{\n    display: inline;\n    row-gap: 1rem;\n    }\n    .lft-sct-nw,.rgt-sect-nw{\n        width: 100%;\n    }\n    }\n\n    [id^=accordionDetail_accordion-plan-monarch] > div:first-child{\n        width: 100%;\n    }\n    .pln-tle-vbgds > div > div > div > div:first-child {\n      z-index: 1;\n    }\n    /* .pln-tle-vbgds > div > div > div > div > [class^=VBG__DS__cap-module]{\n      width: 100% !important;\n    }\n     */\n    [id^=accordionDetail_accor-monar-company-plan] > div ,[id^=accordionDetail_accor-monar-mybiz-plan] > div,[id^=accor-monar-company-plan] > div{\n      padding-bottom: 0px !important;\n    }\n    .mock-crt-icon{\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    background: transparent;\n    cursor: pointer;\n    z-index: 999997;\n}\n.lt-sec-nw-ctnr{\n    height: 400px;\n    overflow-y: auto;\n}\n#accordionItemDetail_accordion-plan-monarch-plans-new-ctnr_0 > div:first-child, #accordionItemDetail_accordion-plan-monarch-plans-new-ctnr_1 > div:first-child{\n    padding-bottom: 0px !important;\n}\n.fcc-bl-main-container{\n    max-height: 150px;\n    overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
